<template>
    <a-drawer :title="title" width="400" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules">
            <a-form-model-item label="设备信息">
                <a-tag color="#2db7f5">
                    {{ item.sno }}
                </a-tag>
                {{ item.name }}
            </a-form-model-item>
            <a-form-model-item label="是否通过" prop="pass">
                <a-radio-group v-model="field.pass" button-style="solid">
                    <a-radio-button :value="true">
                        通过注册
                    </a-radio-button>
                    <a-radio-button :value="false">
                        驳回注册
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="测评功能" prop="exam" v-if="field.pass">
                <a-radio-group v-model="field.exam">
                    <a-radio-button :value="true">
                        开启测评
                    </a-radio-button>
                    <a-radio-button :value="false">
                        关闭测评
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="训练功能" prop="exer" v-if="field.pass">
                <a-radio-group v-model="field.exer">
                    <a-radio-button :value="true">
                        开启训练
                    </a-radio-button>
                    <a-radio-button :value="false">
                        关闭训练
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="设备类型" prop="type" v-if="field.pass">
                <a-radio-group v-model="field.type">
                    <a-radio-button value="Unit">
                        机构类型
                    </a-radio-button>
                    <a-radio-button value="Home">
                        家庭类型
                    </a-radio-button>
                    <a-radio-button value="Both">
                        兼容类型
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="归属机构" prop="unit" v-if="field.pass">
                <a-select show-search v-model="field.unit" :filter-option="false" :not-found-content="null" @search="doLoadUnit">
                    <a-select-option v-for="item in units" :key="item.id" :value="item.id" :label="item.name">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="驳回原因" prop="memo" v-if="!field.pass">
                <a-textarea v-model="field.memo" placeholder="请填写驳回原因" :rows="3" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    提交审核
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            units: [],
            field: {
                ids: '',
                pass: true,
                exam: true,
                exer: true,
                type: 'Unit',
                memo: '',
                unit: ''
            },
            rules: {}
        }
    },
    mounted() {
        this.doLoadUnit()
        this.field.ids = this.item.id
    },
    methods: {
        doLoadUnit(name) {
            this.$http
                .get('/sys/data/user/unit', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.units = result.datas
                })
        },
        doSave() {
            if (!this.field.pass && !this.field.memo) {
                this.$message.error('请填写驳回原因')
                return
            }
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/cts/ate/device/mgr/audit', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('审核成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            this.field.ids = this.item.id
        }
    }
}
</script>
